<template>
  <router-view/>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
  },
  components: {}
})
</script>

<style lang="less">
html,body{
  background-color: #F2F2F2;
  font-family: Arial, Helvetica, sans-serif;
  margin: 0 !important; /*防止el-popup-parent--hidden弹框bug问题*/
  padding: 0 !important; /*防止el-popup-parent--hidden弹框bug问题*/
}
.out{
  width:100%;
  padding: 10px 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 2px 5px #D1D1D1;
}
.el-popup-parent--hidden { 
  overflow: initial !important; /*防止el-popup-parent--hidden弹框bug问题*/
}
/* 输入框样式 */
.el-input__inner::placeholder {
  color: #a8abb2 !important;
}
.el-input__inner{
  color: #333 !important;
}
.myParamsTable{
  width: 100%;
  border-collapse: collapse;
  th{
    text-align: center;
  }
  th, td {
    border: 1px solid #797979; /* 统一单元格边框 */
    padding: 8px;
    max-width: 200px;
  }
}
/* 弹窗样式 */
.el-dialog{
  border-radius: 5px !important;
}
.el-dialog__header, .el-message-box__header{
  border-bottom: 1px solid #f2f2f2 !important;
  background-color: #f2f2f2 !important;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 10px !important;
  margin-right: 0 !important;
  .el-dialog__title{
    font-size: 0.9rem;
  }  
}
.el-message-box__header{
  padding: 10px !important;
}
.el-dialog__headerbtn, .el-message-box__headerbtn{
  height: 45px;
  width: 45px;
  top: 0 !important;
  .el-icon{
    width: 1.3rem;
    height: 1.3rem;
    font-size: 1.3rem; 
    svg{
      width: inherit;
      height: inherit;
      font-size: inherit;
    }
  }
}
.el-message-box__headerbtn{
  top: 0 !important;
  right: 0 !important;
  height: 40px !important;
  width: 40px !important;
}
.cancel:hover{
  color: var(--el-button-hover-text-color) !important;
  border-color: var(--el-button-hover-border-color) !important;
  background-color: var(--el-button-hover-bg-color) !important;
}
.myBox .myBoxConfirmClass{
  background-color: @themeColor !important;
  border: 1px solid @themeColor !important;
  &:hover{
    background-color: @lightBlueBtnBg !important;
    border: 1px solid @lightBlueBtnBg !important;
  }
}
.el-drawer__close-btn{
  .el-icon{
    width: 1.3rem;
    height: 1.3rem;
    font-size: 1.3rem; 
    svg{
      width: inherit !important;
      height: inherit !important;
      font-size: inherit !important;
    }
  }
}
.el-message-box__btns .btnConfirm{
  background-color: @themeColor !important;
  border: 1px solid @themeColor !important;
  &:hover{
    background-color: @lightBlueBtnBg !important;
    border: 1px solid @lightBlueBtnBg !important;
  }
}
/* 头部用户菜单样式 */
.headerOut{
  .info {
    >div{
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      cursor: pointer;
    }
    img {
      width: 35px;
      height: 35px;
      border-radius: 20px;
      margin-right: 5px;
    }
  }
}
.myPopover{
  padding: 0 !important;
  position: absolute;
  top: -25px !important;
  .headPopOut {
    width: 100%;
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: #f1f1f1;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      &:hover {
        cursor: default;
      }
      img {
        width: 45px;
        height: 45px;
        margin-right: 15px;
      }
    }
    .loginName{
      height: 45px;
      line-height: 45px;
      width: 100%;
      background-color: #f1f1f1;
      overflow: hidden;
      text-align: center;
    }
    .menu {
      display: block;
      text-align: center;
      height: auto;
      line-height: 40px;
      padding: 5px;
      div:hover {
        color: #fff;
        background-color: @themeColor;
        border-radius: 3px;
        svg{
          fill: #fff;
        }
      }
    }
    svg{
      margin-right: 3px;
      width: 1.1rem;
      height: 1.1rem;
      vertical-align: text-bottom;
    }
    .exit {
      cursor: pointer;
      text-align: center;
      padding: 5px;
      background-color: #f1f1f1;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      line-height: 35px;
      &:hover{
        color: red;
        svg{
          fill: red;
        }
      }
    }
  }
}
</style>